<template>
  <div class="news">
    <div class="wrapW">
      <div class="left">
        <div class="titleY">Brand Dynamics</div>
        <div class="title">
          <div><span class="hong"></span>品牌动态</div>
          <div class="more">更多<span class="iconfont icon-gengduo1"></span></div>
        </div>
        <div class="newsL" v-if="list[0]">
          <img :src="list[0].img_url">
          <div>{{list[0].title}}</div>
        </div>
      </div>
      <div class="right">
        <div class="titleY">news information</div>
        <div class="title">
          <div><span class="hong"></span>新闻动态</div>
          <div class="more">更多<span class="iconfont icon-gengduo1"></span></div>
        </div>
        <ul>
          <li v-for="(item,index) in list" :key="index">
            <div class="hidden_tetx_one">{{item.title}}</div>
            <div>{{item.release_time}}</div>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="newsD">
      <div class="titleD">
        <div class="titleDT">N</div>
        <div>
          <h4 class="titlex">EWS</h4>
          <h2 class="title">新闻中心</h2>
        </div>
      </div>
      <div class="xian"></div>
      <ul class="newsDU">
        <li v-for="(item,index) in list" :key="index">
          <img :src="item.img_url">
          <div class="hidden_tetx_two name">{{item.title}}</div>
          <div class="time">{{item.release_time}}</div>
          <div class="hidden_tetx_three details">{{item.post_excerpt}}</div>
          <div class="button"><a :href="item.url">查看更多<span class="iconfont">&#xe6a9;</span></a></div>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'news',
  data () {
    return {
      list: []
    }
  },
  mounted () {
    this.getNews()
  },
  methods: {
    scrollTop () {
      let scrollTop = this.$refs.body.scrollTop// 滚动条的高
      if (scrollTop > 500) {
        this.Toptype = 1
        if (!this.countToB) {
          this.countToB = true
        }
      } else {
        this.Toptype = 0
      }
    },
    getNews () {
      let that = this
      this.$axios.get(process.env.API_HOSTT + '/os/getNews', {
        params: {
          type: 1,
          page: 1,
          limit: 3
        }
      }).then(
        function (res) {
          res = res.data.data
          that.list = res.list
          // console.log(list)
          // for (let i = 0 ;i< list.length; i++) {
          //   list[i].release_time = list[i].release_time.split('T')[0]
          // }
          // console.log(list)
          // that.list = list

        }
      ).catch(error => console.log(error))
    }
  }
}
</script>
<style lang="stylus" scoped>
.news
  width 100%
  background #EFEFEF
  padding .6rem 0
  .wrapW
    display flex
    .left
      width 46%
      margin-right 5%
      .newsL
        width 100%
        position relative
        img
          width 100%
        div
          position absolute
          bottom 0rem
          left 0rem
          width 100%
          line-height .48rem
          height .48rem
          color #fff
          font-size .16rem
          background rgba(0,0,0,.6)
          padding-left .12rem
    .right
      width 49%
      ul
        li
          height .52rem
          line-height .52rem
          font-size .16rem
          color #666
          display flex
          justify-content space-between
          .hidden_tetx_one
            position relative
            padding-left .1rem
          .hidden_tetx_one::before
            content ''
            width .06rem
            height .06rem
            background #999999
            position absolute
            top .23rem
            left 0px
            border-radius 50%
        li:hover
          color #D22016
          .hidden_tetx_one::before
            background #D22016
    .titleY
      color #999999
      font-size .28rem
      font-weight bold
      line-height .4rem
    .title
      display flex
      justify-content space-between
      font-size .24rem
      color var(--hei)
      font-weight bold
      margin-bottom .39rem
      margin-top .1rem
      .hong
        width 6px
        height .24rem
        background #D22016
        margin-right .11rem
        display inline-block
        margin-top -1px
        vertical-align middle
      .more
        font-size .16rem
        color #666666
</style>



// WEBPACK FOOTER //
// src/pages/index/components/news.vue